import React, { useState, useEffect } from "react";
import Field from "components/molecules/Field";
import Form from "components/molecules/Form/Form";
import { useForm } from "components/molecules/Form";
import { FiSearch } from "react-icons/fi";
import { IoMdArrowDropdown } from "react-icons/io";
import { HeaderWrap } from "components/atoms/OrderHistory/OrderHistory.styles";
import Select from "components/molecules/Select";

const OrderHistoryHeader = ({ 
  totalCount = 0, 
  onSearch, 
  onFilterChange,
  filters = {},
  customDateRange = { startDate: '', endDate: '' },
  onCustomDateChange
}) => {
  const [form] = useForm();
  const [searchValue, setSearchValue] = useState("");
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedOrderType, setSelectedOrderType] = useState(null);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);

  const statusOptions = [
    { value: "all", label: "All" },
    { value: "new_order", label: "Pending" },
    { value: "delivered", label: "Delivered" },
    { value: "ready", label: "Completed" },
    { value: "cancelled", label: "Canceled" },
  ];

  const orderTypeOptions = [
    { value: "all", label: "All" },
    { value: "delivery", label: "Delivery" },
    { value: "pickup", label: "Pick-up" },
  ];

  const paymentMethodOptions = [
    { value: "all", label: "All" },
    { value: "cash_on_delivery", label: "Cash" },
    { value: "credit_card", label: "Card" },
  ];
  // Debounced search
  useEffect(() => {
    const timer = setTimeout(() => {
      onSearch && onSearch(searchValue);
    }, 500); // 500ms debounce

    return () => clearTimeout(timer);
  }, [searchValue]);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchValue(value);
  };

  const handleStatusChange = (option) => {
    setSelectedStatus(option);
    onFilterChange && onFilterChange('status', option.value);
  };

  const handleOrderTypeChange = (option) => {
    setSelectedOrderType(option);
    onFilterChange && onFilterChange('orderType', option.value);
  };

  const handlePaymentMethodChange = (option) => {
    setSelectedPaymentMethod(option);
    onFilterChange && onFilterChange('paymentMethod', option.value);
  };

  return (
    <HeaderWrap>
      <div className="left-wrap">
        <div className="heading">
          <h2>Orders History</h2>
          <p>Total {totalCount}</p>
        </div>
        <Form form={form}>
          <Form.Item
            type="search"
            rounded
            name="search"
            lg
            placeholder="Search by Order ID, Customer Name, or Location..."
            $bgWhite
            inputSm
            noMargin
            suffix={<FiSearch />}
            value={searchValue}
            onChange={handleSearchChange}
          >
            <Field />
          </Form.Item>
        </Form>
      </div>
      <div className="rightwrapper">
        <div className="date-wrap">
          <div className="custom-date-picker">
            <input
              type="date"
              value={customDateRange.startDate}
              onChange={(e) => onCustomDateChange && onCustomDateChange('startDate', e.target.value)}
              placeholder="Start Date"
              max={customDateRange.endDate || undefined}
            />
            <span>to</span>
            <input
              type="date"
              value={customDateRange.endDate}
              onChange={(e) => onCustomDateChange && onCustomDateChange('endDate', e.target.value)}
              placeholder="End Date"
              min={customDateRange.startDate || undefined}
            />
          </div>
        </div>
        <div className="right-content">
          <span>Filter by</span>
          <div className="drop-down">
            <Select
              placeholder="Status"
              options={statusOptions}
              noMargin
              value={selectedStatus}
              onChange={(e) => handleStatusChange(e.target.value)}
            />
          </div>
          <div className="drop-down">
            <Select
              placeholder="Type"
              options={orderTypeOptions}
              noMargin
              value={selectedOrderType}
              onChange={(e) => handleOrderTypeChange(e.target.value)}
            />
          </div>
          <div className="drop-down">
            <Select
              placeholder="Payment"
              options={paymentMethodOptions}
              noMargin
              value={selectedPaymentMethod}
              onChange={(e) => handlePaymentMethodChange(e.target.value)}
            />
          </div>
        </div>
      </div>
    </HeaderWrap>
  );
};

export default OrderHistoryHeader;
